import { Injectable } from '@angular/core';


declare const gtag: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor() { 
    // this.loadScript()
  }

  private loadScript(){
    return new Promise((resolve, reject) => {
      const scriptElement = window.document.createElement('script');
      scriptElement.src = "https://www.googletagmanager.com/gtag/js?id=G-RH8QHPFM40";
      scriptElement.async;
      scriptElement.defer;
      scriptElement.onload = () => {
        resolve("");
      };

      scriptElement.onerror = () => {
        reject();
      };

      window.document.head.appendChild(scriptElement);

      const scriptElement2 = window.document.createElement('script');
      scriptElement2.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-RH8QHPFM40');`;
      scriptElement2.onload = () => {
        resolve("");
      };

      scriptElement2.onerror = () => {
        reject();
      };

      window.document.head.appendChild(scriptElement2);
    });
  }

  sendAnalytics(eventName: string, eventData: any) {
    if(gtag){
      gtag('event', eventName, { ...eventData });
    }
  }
}

